import { FieldSkeleton } from './components/field-skeleton';

export const SelectTypeSkeleton = ({ rows = 2 }: { rows?: number }) => (
  <div className='flex flex-col gap-4 animate-pulse'>
    {Array.from({ length: rows }, (_, i) => (
      <FieldSkeleton key={i} />
    ))}
  </div>
);
